import { render, staticRenderFns } from "./AdvancedShootingChart.vue?vue&type=template&id=164ffbb4&scoped=true&"
import script from "./AdvancedShootingChart.vue?vue&type=script&lang=js&"
export * from "./AdvancedShootingChart.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedShootingChart.vue?vue&type=style&index=0&id=164ffbb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ffbb4",
  null
  
)

export default component.exports